import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zm-11 9H3V5h9v7z"
}), 'FeaturedVideoSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FeaturedVideoSharp.js
// module id = 3537
// module chunks = 2